<template>
  <div class="container">
    <HeaderView />
    <div :class="{ 'bg-content': $store.state.screenWidth > 375, 'bg-content-se': $store.state.screenWidth <= 375, 'bg-content-4': $store.state.screenWidth <=320 }">
      <div class="workshop-page">
        <div class="workshop-toolbar">
          <div class="workshop-title">
            <span class="title-icon"><i class="ti ti-run"></i></span>
            <div>
              <p>RMUTL Open House</p>
              <h2>รายการกิจกรรม</h2>
            </div>
          </div>
          <router-link to="/activity" class="back-button">
            <i class="ti ti-chevron-left"></i>
            <span>ย้อนกลับ</span>
          </router-link>
        </div>

        <div class="search-panel">
          <div class="input-icon">
            <input
              v-model="searchtext"
              type="text"
              class="form-control"
              placeholder="ค้นหาชื่อกิจกรรมหรือหลักสูตร"
            >
            <span class="input-icon-addon">
              <i class="ti ti-search"></i>
            </span>
          </div>
          <span class="result-count">{{ filterData.length }} กิจกรรม</span>
        </div>

        <div class="workshop-grid">
          <div
            class="workshop-card"
            v-for="(ws, i) in filterData"
            :key="'ws' + i"
          >
            <img
              class="workshop-watermark"
              :src="'/static/img/logo/' + ws.fac_logo"
              :alt="ws.workshop_dep"
            />
            <div class="workshop-main">
              <div class="workshop-logo">
                <img :src="'/static/img/logo/' + ws.fac_logo" :alt="ws.workshop_dep" />
              </div>
              <div class="workshop-info">
                <h3>{{ ws.workshop_name }}</h3>
                <p>{{ ws.workshop_dep }}</p>
              </div>
            </div>
          </div>
          <div class="empty-workshop" v-if="filterData.length === 0">
            <i class="ti ti-file-search"></i>
            <span>ไม่พบกิจกรรมที่ค้นหา</span>
          </div>
          <div class="workshop-spacer" v-if="ws_list.length > 2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import FooterbarView from './layouts/FooterbarView.vue'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  components: {
    HeaderView,
    FooterbarView
  },
  data () {
    return {
      ws_list: [],
      searchtext: ''
    }
  },
  computed: {
    filterData: function () {
      let text = this.searchtext.trim()
      return this.ws_list.filter(workshop => {
        if (workshop.workshop_name !== null) {
          return (
            workshop.workshop_name.indexOf(text) > -1 || workshop.workshop_dep.indexOf(text) > -1
          )
        }
      })
    }
  },
  methods: {
    async getWorkShopList () {
      this.$store.state.isLoading = true
      api.getWorkshop(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.ws_list = result.data
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก'
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        _error => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        }
      )
    }
  },
  async mounted () {
    const auth = this.callbackToken(this.$store.state.user.citizenId)
    if (auth) {
      await this.checkUser()
      await this.getWorkShopList()
    } else {
      localStorage.clear()
      this.$router.push('/').catch(() => { })
    }
  }
}
</script>

<style scoped>
.workshop-page {
  width: min(1180px, calc(100% - 20px));
  margin: 0 auto;
  padding: 22px 0 110px;
  color: #2f241b;
  font-family: 'Mitr', sans-serif;
}

.workshop-toolbar {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.workshop-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-icon {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 14px 28px rgba(185, 130, 46, 0.22);
  font-size: 28px;
}

.workshop-title p {
  margin: 0 0 2px;
  color: #8a714f;
  font-size: 13px;
}

.workshop-title h2 {
  margin: 0;
  color: #2f241b;
  font-size: 28px;
  font-weight: 600;
}

.back-button {
  min-height: 42px;
  padding: 0 16px;
  border: 1px solid rgba(116, 87, 60, 0.16);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #5a3b25;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 10px 24px rgba(76, 50, 31, 0.08);
  font-size: 15px;
}

.search-panel {
  margin-bottom: 18px;
  padding: 14px;
  border: 1px solid rgba(116, 87, 60, 0.14);
  border-radius: 8px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 16px 38px rgba(76, 50, 31, 0.1);
}

.search-panel .form-control {
  min-height: 44px;
  border-color: #dccdb9;
  border-radius: 8px;
  color: #2f241b;
  font-family: 'Mitr', sans-serif;
}

.search-panel .form-control:focus {
  border-color: #b9822e;
  box-shadow: 0 0 0 0.25rem rgba(185, 130, 46, 0.16);
}

.result-count {
  padding: 9px 12px;
  border-radius: 8px;
  color: #5a3b25;
  background: #fff4df;
  font-size: 14px;
  white-space: nowrap;
}

.workshop-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.workshop-card {
  position: relative;
  min-height: 112px;
  padding: 14px;
  overflow: hidden;
  border: 1px solid rgba(116, 87, 60, 0.12);
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.94), rgba(255, 250, 240, 0.86)),
    #ffffff;
  box-shadow: 0 16px 34px rgba(76, 50, 31, 0.1);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.workshop-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 22px 44px rgba(76, 50, 31, 0.15);
}

.workshop-watermark {
  position: absolute;
  right: -20px;
  bottom: -26px;
  width: 142px;
  height: 142px;
  object-fit: contain;
  opacity: 0.08;
}

.workshop-logo {
  position: relative;
  z-index: 1;
  width: 54px;
  height: 54px;
  border: 1px solid rgba(185, 130, 46, 0.16);
  border-radius: 8px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(76, 50, 31, 0.09);
}

.workshop-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.workshop-info {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.workshop-main {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 84px;
  min-width: 0;
}

.workshop-info h3 {
  margin: 0;
  color: #2f241b;
  display: -webkit-box;
  overflow: hidden;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.workshop-info p {
  margin: 8px 0 0;
  color: #7c654f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.empty-workshop {
  grid-column: 1 / -1;
  min-height: 180px;
  border: 1px dashed rgba(116, 87, 60, 0.24);
  border-radius: 8px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: #8a714f;
  background: rgba(255, 255, 255, 0.62);
  font-size: 15px;
}

.empty-workshop i {
  font-size: 34px;
  color: #b9822e;
}

.workshop-spacer {
  grid-column: 1 / -1;
  height: 100px;
}

@media (max-width: 991px) {
  .workshop-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .workshop-page {
    width: calc(100% - 14px);
    padding-top: 14px;
  }

  .workshop-toolbar {
    align-items: flex-start;
  }

  .workshop-title h2 {
    font-size: 23px;
  }

  .back-button span {
    display: none;
  }

  .search-panel {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .result-count {
    justify-self: start;
  }

  .workshop-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .workshop-card {
    min-height: 104px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Workshop.vue